import { createStore } from "zustand";

export type MicroCart = {
	id: string;
	items: MicroCartItem[];
	totalPrice: number;
};

export type MicroCartItem = {
	id: string;
	quantity: number;
	stock?: string;
};

export interface IMicroCartState {
	carts: Map<string, MicroCart>;
	allColorVariantYarnsSoldOut: boolean;

	registerCart: (cart: MicroCart) => void;
	updateCart: (cart: MicroCart) => void;
	removeMicroCart: (id: string) => void;
	resetMicroCart: () => void;
	setAllColorVariantYarnsSoldOut: (value: boolean) => void;
	isReset: boolean;
	toggleReset: () => void;
}

export const microcartFactory = (initialState?: Partial<IMicroCartState>) => {
	return createStore<IMicroCartState>((set, _get) => ({
		...initialState,

		carts: new Map<string, MicroCart>(),
		allColorVariantYarnsSoldOut: false,
		isReset: false,
		toggleReset: () => {
			set((state) => ({ isReset: !state.isReset }));
		},
		registerCart: (cart) => {
			set((state) => {
				return {
					carts: new Map(state.carts.set(cart.id, cart)),
				};
			});
		},
		updateCart: (cart) => {
			set((state) => ({
				carts: new Map(state.carts.set(cart.id, cart)),
			}));
		},
		removeMicroCart: (id: string) => {
			set((state) => {
				const newMap = new Map(state.carts);
				newMap.delete(id);
				return { carts: newMap };
			});
		},
		setAllColorVariantYarnsSoldOut: (value: boolean) => {
			set({ allColorVariantYarnsSoldOut: value });
		},
		resetMicroCart: () =>
			set(() => ({
				carts: new Map<string, MicroCart>(),
				isReset: true,
			})),
	}));
};
